<template>
  <div v-observe-visibility="visibilityChanged" class="product_info">
    <div class="product_title_wrap">
      <strong class="product_title">과정정보</strong>
    </div>
    <div class="product_option">
      <span class="option_title">학습기간</span>
      <div class="select_box">
        <select :value="selectedProductKey" title="수강 신청할 학습기간 선택" @change="changeProduct($event)">
          <option
            v-for="(productObj, idx) in productList" :key="idx"
            :value="productObj.eduGrpCd+'|@|'+productObj.corsCd+'|@|'+productObj.corsYr+'|@|'+productObj.corsDgrCd">
            {{ $moment(productObj.eduStartDtm, 'YYYYMMDDHH').isValid() ? $moment(productObj.eduStartDtm, 'YYYYMMDDHH').format('YYYY.MM.DD') : productObj.eduStartDtm }}
            ~
            {{ $moment(productObj.eduEndDtm, 'YYYYMMDDHH').isValid() ? $moment(productObj.eduEndDtm, 'YYYYMMDDHH').format('YYYY.MM.DD') : productObj.eduEndDtm }}
          </option>
        </select>
      </div>
    </div>
    <div class="product_discount">
      <!-- [2020-05-22] 마크업 수정 -->
      <ul>
        <li class="product_discount_list">
          <strong class="discount_text">정가<em v-if="selectedProduct.discCntnt" class="discount_rate">{{ selectedProduct.discCntnt }}</em></strong>
          <span class="discount_sum"><em :class="{'discount_line': selectedProduct.discAmt && Number(selectedProduct.discAmt) > 0 }" >{{ selectedProduct.fxprcEdcct | numFormat }}</em><em class="discount_unit">원</em></span>
        </li>

        <li v-if="selectedProduct.discAmt && Number(selectedProduct.discAmt) > 0" class="product_discount_list">
          <strong class="discount_text">할인 금액</strong>
          <span class="discount_sum"><span>-{{ selectedProduct.discAmt | numFormat }}</span><em class="discount_unit">원</em></span>
        </li>
      </ul>
      <!-- //[2020-05-22] 마크업 수정 -->
    </div>
    <div class="product_payment">
      <!-- [2020-05-22] 마크업 수정 -->
      <strong class="payment_text">총 금액<em class="payment_tax"> {{ Number(selectedProduct.ucstTaxAmt) > 0 ? '(VAT포함)' : '(VAT없음)' }}</em></strong>
      <span class="payment_sum">{{ selectedProduct.ucstSmtotAmt | numFormat }}<em class="payment_unit">원</em></span>
      <!-- [2020-05-22] 마크업 수정 -->
    </div>
    <div class="product_share">
      <button class="btn_share" @click="snsLinkOpen = !snsLinkOpen"><span class="share_txt">공유하기</span></button>
      <div :class="{'is-active': snsLinkOpen}" class="product_sns_list"><!-- sns 목록 활성화 클래스 : is-active -->
        <ul>
          <li v-if="shareKakaoActive" class="product_sns_item">
            <button class="btn_sns kakao_link" @click="shareKakao"><span class="sns_txt">카카오톡<em class="blind">으로 공유하기</em></span></button>
          </li>
          <li v-if="shareFacebookActive" class="product_sns_item">
          <button class="btn_sns facebook_link" @click="shareFacebook"><span class="sns_txt">페이스북<em class="blind">으로 공유하기</em></span></button></li>
          <li class="product_sns_item">
            <button
              v-clipboard:copy="shareCopyUrl" v-clipboard:success="toastCopySuccess"
              class="btn_sns url_link"><span class="sns_txt">링크 Copy<em class="blind">로 공유하기</em></span></button>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn_product_wrap">
      <!-- [2020-05-22] 마크업 수정 -->
      <button v-if="selectedProduct.ucstSmtotAmt > 0" type="button" class="btn_product ico_product" @click="addCart"><span class="btn_text">장바구니</span></button>
      <button type="button" class="btn_product" @click="order"><span class="btn_text">수강신청</span></button>
    </div>
  </div>
</template>

<script>
import { isEmpty, find } from 'lodash'

export default {
  name: 'MmpPromoCart',
  props: {
    eduGrpCd: { // 교육그룹코드
      type: String,
      default: ''
    },
    corsCd: { // 과정코드
      type: String,
      default: ''
    }
  },
  data () {
    return {
      snsLinkOpen: false
    }
  },
  computed: {
    promoInfoStore () {
      return window.vue.getStore('promoInfo')
    },
    shareKakaoActive () {
      return !isEmpty(this.promoInfoStore.state.promoInfo.kakaoCtfcKeyCntnt)
    },
    shareFacebookActive () {
      return !isEmpty(this.promoInfoStore.state.promoInfo.facbkCtfcKeyCntnt)
    },
    productList () {
      return this.promoInfoStore.state.productDetail.productList
    },
    selectedProductKey () {
      return this.promoInfoStore.state.productDetail.selectedProductKey
    },
    selectedProduct () {
      if (isEmpty(this.selectedProductKey)) {
        return {}
      }

      var splitArray = this.selectedProductKey.split('|@|')

      var selectKeyObj = {
        eduGrpCd: splitArray[0],
        corsCd: splitArray[1],
        corsYr: splitArray[2],
        corsDgrCd: splitArray[3]
      }

      var findObj = find(this.productList, selectKeyObj)

      return findObj
    },
    shareCopyUrl () {
      return window.location.href
    }
  },
  created () {
    console.log('created :', this._uid)

    this.$parent.setProductInfo(this.eduGrpCd, this.corsCd)
  },
  beforeDestroy () {
    console.log('beforeDestroy :', this._uid)
  },
  methods: {
    shareKakao () {
      this.snsLinkOpen = false
      this.$parent.shareKakao()
    },
    shareFacebook () {
      this.snsLinkOpen = false
      this.$parent.shareFacebook()
    },
    changeProduct (e) {
      this.promoInfoStore.commit('SET_PRODUCT_SELECTED', e.target.value)
    },
    visibilityChanged (isVisible, entry) {
      this.promoInfoStore.commit('SET_PRODUCT_VISIBLE', isVisible)
    },
    toastCopySuccess (e) {
      this.$popup.toast('복사되었습니다.')
      this.snsLinkOpen = false
    },
    addCart () {
      this.$parent.addCart()
    },
    order () {
      this.$parent.order()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/promotion/MmpPromoCart.vue